import React from 'react'
import { createContext } from 'react'

export default createContext({
  lightbox: <React.Fragment />,
  setLightbox: () => {},
})
